<template>
  <div class="content comp_content" style="padding: 0 30px" v-loading="loading">
    <h2 class="big_title">
      <div class="search">
        <input
          type="text"
          class="search_box"
          placeholder="请输入搜索内容"
          v-model="key"
        />
        <span class="search_btn" @click="serachKey"
          ><i class="el-icon-search"></i
        ></span>
      </div>
      <span>通讯录</span>
    </h2>
    <div class="big_title" v-if="addressBookId == 0 ? false : true">
      <div class="search">
        <div class="select_box" v-if="addressBookId == 0 ? false : true">
          <el-select
            v-model="value"
            placeholder="请选择支部获取数据"
            @change="changeValue()"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.organization_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="address_book">
      <el-table
        :data="tableData"
        class="common_table"
        border
        style="width: 100%"
      >
        <el-table-column
          fixed
          type="index"
          prop="real_name"
          label="序号"
          width="50"
        ></el-table-column>
        <el-table-column
          width="100"
          fixed
          prop="real_name"
          label="姓名"
        ></el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          :formatter="stateFormatsex"
          width="50"
        ></el-table-column>
        <el-table-column prop="age" label="年龄" width="50"></el-table-column>
        <el-table-column
          width="150"
          prop="phone"
          label="电话号码"
        ></el-table-column>
        <el-table-column
          width="150"
          prop="education"
          label="文化程度"
        ></el-table-column>
        <el-table-column prop="address" label="联系地址"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
      <el-pagination
        background
        layout="prev, pager, next,total"
        :page-size="limit"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      limit:50,
      loading: true,
      tableData: [],
      addressBookId: "",
      total: null,// 总条数
      page: 1,// 页数
      key: "",// 查询关键字

      options: [
        {
          value: 'id',
          label: 'organization_name'
        }
      ],// 支部数据
      value: '', // 支部数据id
    };
  },
  created() {
    this.addressBookId = sessionStorage.getItem("ISCOM")
  },
  mounted() {
    this.getInfo();
    this.getBranch();
  },
  methods: {
    async serachKey() {
      console.log(this.key);
      this.getInfo();
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val
      this.getInfo();
    },

    // 获取信息
    async getInfo() {
      let data = await this.PublicApi(
        "/admin/organization/queryAddressBook", {
        organization_id: this.value,
        page: this.page,
        limit: this.limit,
        key: this.key,
      }
      )
      this.total = data.data.count
      this.tableData = []
      this.tableData = data.data.list
      this.loading = false
    },
    // 获取支部信息
    async getBranch() {
      let data = await this.PublicApi(
        "admin/organization/getsBranch"
      )
      this.options = data.data
      this.options.push({
        id: '',
        organization_name: '委员通讯录'
      })
      this.loading = false
    },
    // 获取支部信息
    changeValue(i) {
      this.getInfo();
    },
    stateFormatsex(row, column) {
      if (row.sex === "男") {
        return "男";
      }
      if (row.sex === "女") {
        return "女";
      } else {
        return "未知";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/MailList/index.vue